import { render, staticRenderFns } from "./EditSeriesPanel.vue?vue&type=template&id=2220f10e"
import script from "./EditSeriesPanel.vue?vue&type=script&lang=js"
export * from "./EditSeriesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports